interface Props {
  text: string;
  color: string;
  x: number;
  y: number;
  width: number;
  isTextInside: boolean;
}

export const Legend = ({ text, color, x, y, width, isTextInside }: Props) => {
  const positiveWidth = Math.abs(width);
  return (
    <g>
      <path
        d={`M${x},${y} h${positiveWidth} q4,0 4,4 v16 q0,4 -4,4 h-${positiveWidth} z`}
        fill={color}
      />
      <text
        textAnchor={isTextInside ? 'end' : 'start'}
        transform={`translate(${positiveWidth} ${y})`}
        dx={isTextInside ? 0 : 24}
        dy={16}
        fontSize={12}
        fill={'#fff'}
      >
        {text}
      </text>
    </g>
  );
};
